module.exports = __webpack_public_path__ + "static/media/grafico-unicred-centro-sul-4.0d969d79.png";